module.exports = __webpack_public_path__ + "static/media/dark_logo.b4fd34b0.svg";